export default {
  insurance: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  insured: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  stage: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  sinisterCode: {
    value: '',
    maxlength: '20',
    required: false,
    state: null
  },
  expert: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  expertID: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null
  },
  analyst: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  analystID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  sinisterDateStart: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  sinisterDateEnd: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  lighthouse: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  ranking: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  schedulingTypeID: {
    value: null,
    options: [],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/distribution/distribution-form.js